// Login form label
export const LoginForm = {
	WELCOME_MESSAGE: "Welcome to Moneyview Merchant Portal",
	SIGN_IN_TITLE: "Please sign in to access the portal",
	SIGN_IN_INFO: "Enter your Username and Password to continue",
	USER_NAME_ERROR_TEXT: "Please enter your Username",
	USER_NAME_VALID_ERROR_TEXT: "Please enter a valid email ID",
	PASSWORD_ERROR_TEXT: "Please enter your Password",
	USERNAME: "Username",
	PASSWORD_LABEL: "Password",
	SIGN_IN: "SIGN IN",
	EMAIL: "email",
	PASSWORD: "password",
};

export const MODULE_NAME = "auth";

export default LoginForm;
